export default "__VITE_ASSET__e57fcb75__"